import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import _ from "lodash";
import TitleBar from "../_common/TitleBar";
import { 
  DataGrid,
  GridToolbarContainer,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  useGridApiContext,
  gridFilteredSortedRowIdsSelector,
  gridVisibleColumnFieldsSelector, 
} from "@mui/x-data-grid";
import MenuItem from '@mui/material/MenuItem'
import { actionScripts } from "../../_helpers/actionScripts";
import { locale } from "moment";
import { Typography } from "@mui/material";

const getJson = (apiRef) => {
  // Select rows and columns
  const filteredSortedRowIds = gridFilteredSortedRowIdsSelector(apiRef);
  const visibleColumnsField = gridVisibleColumnFieldsSelector(apiRef);

  // Format the data. Here we only keep the value
  const data = filteredSortedRowIds.map((id) => {
    const row = {};
    visibleColumnsField.forEach((field) => {
      row[field] = apiRef.current.getCellParams(id, field).value;
    });
    return row;
  });

  // Stringify with some indentation
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#parameters
  return JSON.stringify(data, null, 2);
};

const exportBlob = (blob, filename) => {
  // Save the blob in a json file
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();

  setTimeout(() => {
    URL.revokeObjectURL(url);
  });
};

function JsonExportMenuItem(props) {
  const apiRef = useGridApiContext();

  const { hideMenu } = props;

  return (
    <MenuItem
      onClick={() => {
        const jsonString = getJson(apiRef);
        const blob = new Blob([jsonString], {
          type: 'text/json',
        });
        exportBlob(blob, 'data.json');

        // Hide the export menu after the export
        //hideMenu?.();
      }}
    >
      Export JSON
    </MenuItem>
  );
}

JsonExportMenuItem.propTypes = {
  hideMenu: PropTypes.func,
};

const csvOptions = { delimiter: ',' };

function CustomExportButton(props) {
  return (
    <GridToolbarExportContainer {...props}>
      <GridCsvExportMenuItem options={csvOptions} />
      <JsonExportMenuItem />
    </GridToolbarExportContainer>
  );
}

function CustomToolbar(props) {
  return (
    <GridToolbarContainer {...props}>
      <CustomExportButton />
    </GridToolbarContainer>
  );
}

function CustomDaysCell({dates}) {
    debugger
    return (<div>
        {dates.map((date, index) => (

            <>
                <span>&nbsp;&nbsp;</span>
                <span className="badge badge-success p-1">
                  {new Date(date).toLocaleDateString(locale, { weekday: 'long' })}&nbsp;
                  {new Date(date).toLocaleDateString()}
                </span>
                {index !== 0 && index % 3 === 0 &&
                  <br />
                }
            </>
        ))}
    </div>)
}

class ContractorWeeklyReport extends Component {
  dataGridColumns = [
    {
      field: "id",
      headerName: "ContractorId",
      hide: true,
      disableExport: true
    },
    {
      field: "contractorName",
      headerName: "Contractor",
      width: 300
    },
    {
      field: "weekEnding",
      headerName: "Week Ending",
      width: 300
    },
    {
      field: "dates",
      headerName: "Days",
      width: 500,
      renderCell: (params) => 
        <CustomDaysCell dates={params.row.dates} />
    }
  ];

  getData = () => {
    const { report } = this.props;
    return _.orderBy(
      report.contractorWeeklyReportData
    );
  };


  render() {
    const { report } = this.props;
    const data = report.contractorWeeklyReportData ? this.getData() : [];
    return (
      <React.Fragment>
        <TitleBar titleText={"Contractor Weekly Report"} />
        <div className="card mx-2">
          <div className="card-body">
            <h3>Contrator Weekly Report</h3>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report Created:</label>
              <div className="col-sm-3">
                <input
                  type="text"
                  disabled
                  className="form-control"
                  value={report.created}
                />
              </div>
            </div>
            <div className="form-row form-group">
              <label className="col-sm-3 col-form-label">Report Remarks:</label>
              <div className="col-sm-5">
                <textarea className="form-control" rows={3} />
              </div>
            </div>
            <div style={{ height: 300, width: '100%' }}>
              <DataGrid
                className="table table-hover"
                rows={data}
                columns={this.dataGridColumns}
                pageSize={5}
                disableSelectionOnClick={true}
                rowsPerPageOptions={[5]}
                components={{ Toolbar: CustomToolbar }}
              />
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  report: state.reports.openReports[ownProps.tab.tabId],
});

export default connect(mapStateToProps)(ContractorWeeklyReport);
